export const bodys = [
        {
            "code":"310115",
            "sellPrice":2490,
            "name":"浦东",
            "count":"0",
            "longitude":"121.606531",
            "latitude":"31.208002",
            "touch_lng":"121.592597",
            "touch_lat":"31.283966"
        },
        {
            "code":"310112",
            "sellPrice":1990,
            "name":"闵行",
            "count":"0",
            "longitude":"121.408171",
            "latitude":"31.091186",
            "touch_lng":"121.304717",
            "touch_lat":"31.221620"
        },
        {
            "code":"310113",
            "sellPrice":2130,
            "name":"宝山",
            "count":"0",
            "longitude":"121.428830",
            "latitude":"31.369478",
            "touch_lng":"121.381863",
            "touch_lat":"31.366819"
        },
        {
            "code":"310114",
            "sellPrice":2130,
            "name":"嘉定",
            "count":"0",
            "longitude":"121.285054",
            "latitude":"31.318139",
            "touch_lng":"121.313125",
            "touch_lat":"31.264967"
        },
        {
            "code":"310107",
            "sellPrice":4090,
            "name":"普陀",
            "count":"0",
            "longitude":"121.407503",
            "latitude":"31.256756",
            "touch_lng":"121.442085",
            "touch_lat":"31.269952"
        },
        {
            "code":"310104",
            "sellPrice":5730,
            "name":"徐汇",
            "count":"0",
            "longitude":"121.445113",
            "latitude":"31.175099",
            "touch_lng":"121.441618",
            "touch_lat":"31.200958"
        },
        {
            "code":"310117",
            "sellPrice":2290,
            "name":"松江",
            "count":"0",
            "longitude":"121.265155",
            "latitude":"31.045702",
            "touch_lng":"121.322898",
            "touch_lat":"31.142778"
        },
        {
            "code":"310110",
            "sellPrice":2760,
            "name":"杨浦",
            "count":"0",
            "longitude":"121.535920",
            "latitude":"31.294893",
            "touch_lng":"121.515279",
            "touch_lat":"31.333991"
        },
        {
            "code":"310105",
            "sellPrice":5360,
            "name":"长宁",
            "count":"0",
            "longitude":"121.387923",
            "latitude":"31.211509",
            "touch_lng":"121.421632",
            "touch_lat":"31.223490"
        },
        {
            "code":"310109",
            "sellPrice":5690,
            "name":"虹口",
            "count":"0",
            "longitude":"121.489512",
            "latitude":"31.283347",
            "touch_lng":"121.504428",
            "touch_lat":"31.269288"
        },
        {
            "code":"310108",
            "sellPrice":3090,
            "name":"新静安",
            "count":"0",
            "longitude":"121.451768",
            "latitude":"31.287034",
            "touch_lng":"121.463860",
            "touch_lat":"31.256370"
        },
        {
            "code":"310101",
            "sellPrice":13060,
            "name":"黄浦",
            "count":"0",
            "longitude":"121.488587",
            "latitude":"31.220653",
            "touch_lng":"121.496963",
            "touch_lat":"31.214851"
        },
        {
            "code":"310118",
            "sellPrice":5060,
            "name":"青浦",
            "count":"0",
            "longitude":"121.216900",
            "latitude":"31.196892",
            "touch_lng":"121.098795",
            "touch_lat":"31.156357"
        },
        {
            "code":"310106",
            "sellPrice":10290,
            "name":"静安",
            "count":"0",
            "longitude":"121.456090",
            "latitude":"31.236320",
            "touch_lng":"121.462729",
            "touch_lat":"31.236534"
        },
        {
            "code":"310120",
            "sellPrice":1690,
            "name":"奉贤",
            "count":"0",
            "longitude":"121.445025",
            "latitude":"30.999746",
            "touch_lng":"121.445025",
            "touch_lat":"30.999746"
        }
]
export const plate = [
  {
    name: '西渡街道',
    longitude: '121.441193',
    latitude: '30.992411',
    count: 0,
  },
  {
    name: '奉浦街道',
    longitude: '121.459239',
    latitude: '30.942632',
    count: 0,
  },
  {
    name: '南桥镇',
    longitude: '121.458812',
    latitude: '30.903259',
    count: 0,
  },
  {
    name: '庄行镇',
    longitude: '121.395462',
    latitude: '30.895552',
    count: 0,
  },
  {
    name: '金汇镇',
    longitude: '121.50142',
    latitude: '30.98916',
    count: 0,
  },
  { name: '柘林镇', longitude: '121.465678', latitude: '30.871099', count: 0 },
  { name: '青村镇' ,longitude: '121.581237', latitude: '30.923048', count: 0 },
  { name: '奉城镇',longitude: '121.657536', latitude: '30.909435', count: 0 },
  { name: '四团镇', longitude: '121.723198', latitude: '30.938736', count: 0 },
  { name: '海湾镇', longitude: '121.567794', latitude: '30.857192', count: 0 },
  { name: '金海街道', longitude: '121.4749', latitude: '30.955313', count: 0 },
  {
    name: '海湾旅游区',
    longitude: '121.531756',
    latitude: '30.824725',
    count: 0,
  },
]

